'use strict';

/**
 * Возвращает ссылку на parentIFrame, если код выполняется внутри iframe и подключен iframeResizer
 * https://iframe-resizer.com/api/child/#Methods
 *
 * @returns {TFramePageInfo | undefined} Возвращает объект parentIFrame или undefined.
 */
const getParentIFrame = () => window?.parentIFrame;

exports.getParentIFrame = getParentIFrame;
//# sourceMappingURL=getParentIFrame.js.map
